import clickOk from '../click_ok.json';
import practiceInstruction from '../spelling_practice_instruction.json';
import practiceInstructionStart from '../spelling_practice_instruction_start.json';
import clickOKInstruction from '../spelling_click_ok_practice_instruction.json';
import practiceInstructionReady from '../spelling_practice_instruction_ready.json';
import practiceInstructionActive from '../spelling_practice_instruction_active.json';
import practiceInstructionClearButton from '../spelling_practice_instruction_clear_button.json';
import replayInstruction from '../spelling_replay_instruction.json';
import practiceInstructionSpanish from '../spanish/spelling_practice_instruction_spa.json';
import practiceInstructionStartSpanish from '../spanish/spelling_practice_instruction_start_spa.json';
import clickOKInstructionSpanish from '../spanish/spelling_click_ok_practice_instruction_spa.json';
import practiceInstructionReadySpanish from '../spanish/spelling_practice_instruction_ready_spa.json';
import practiceInstructionActiveSpanish from '../spanish/spelling_practice_instruction_active_spa.json';
import clickOkSpanish from '../spanish/clic_continuare_2021.json';
import practiceInstructionClearButtonSpanish from '../spanish/spelling_practice_instruction_clear_button_spa.json';
import replayInstructionSpanish from '../spanish/spelling_replay_instruction_spa.json';
import { SPELLING_AUDIO_INSTRUCTIONS } from '../../spelling/spellingConstants';
import { LANGUAGES } from '../../common/localization';

export const SPELLING_CAPTIONS = {
    [SPELLING_AUDIO_INSTRUCTIONS[LANGUAGES.ENGLISH].practiceInstruction]: practiceInstruction,
    [SPELLING_AUDIO_INSTRUCTIONS[LANGUAGES.ENGLISH]
        .practiceInstructionStart]: practiceInstructionStart,
    [SPELLING_AUDIO_INSTRUCTIONS[LANGUAGES.ENGLISH].clickOKInstruction]: clickOKInstruction,
    [SPELLING_AUDIO_INSTRUCTIONS[LANGUAGES.ENGLISH]
        .practiceInstructionReady]: practiceInstructionReady,
    [SPELLING_AUDIO_INSTRUCTIONS[LANGUAGES.ENGLISH]
        .practiceInstructionActive]: practiceInstructionActive,
    [SPELLING_AUDIO_INSTRUCTIONS[LANGUAGES.ENGLISH].clickOk]: clickOk,
    [SPELLING_AUDIO_INSTRUCTIONS[LANGUAGES.ENGLISH]
        .practiceInstructionClearButton]: practiceInstructionClearButton,
    [SPELLING_AUDIO_INSTRUCTIONS[LANGUAGES.ENGLISH].replayInstruction]: replayInstruction,
};

export const SPELLING_SPA_CAPTIONS = {
    [SPELLING_AUDIO_INSTRUCTIONS[LANGUAGES.SPANISH]
        .practiceInstruction]: practiceInstructionSpanish,
    [SPELLING_AUDIO_INSTRUCTIONS[LANGUAGES.SPANISH]
        .practiceInstructionStart]: practiceInstructionStartSpanish,
    [SPELLING_AUDIO_INSTRUCTIONS[LANGUAGES.SPANISH].clickOKInstruction]: clickOKInstructionSpanish,
    [SPELLING_AUDIO_INSTRUCTIONS[LANGUAGES.SPANISH]
        .practiceInstructionReady]: practiceInstructionReadySpanish,
    [SPELLING_AUDIO_INSTRUCTIONS[LANGUAGES.SPANISH]
        .practiceInstructionActive]: practiceInstructionActiveSpanish,
    [SPELLING_AUDIO_INSTRUCTIONS[LANGUAGES.SPANISH].clickOk]: clickOkSpanish,
    [SPELLING_AUDIO_INSTRUCTIONS[LANGUAGES.SPANISH]
        .practiceInstructionClearButton]: practiceInstructionClearButtonSpanish,
    [SPELLING_AUDIO_INSTRUCTIONS[LANGUAGES.SPANISH].replayInstruction]: replayInstructionSpanish,
};
